import { defineStore } from 'pinia'
import type { IDhlShipment } from '@team-milva/lab-models/resources'
import { collection, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '@/firebase/init'
import { useAccountStore } from '@/stores/accountStore'

export const useDhlShipmentStore = defineStore('dhlShipment', {
  state: () => ({
    allDhlShipments: [] as IDhlShipment[],
    unsubscribeAllDhlShipments: null as (() => void) | null,
  }),

  getters: {
    allDhlShipmentsLoaded: (state): boolean => !!state.unsubscribeAllDhlShipments,
  },

  actions: {
    getDhlShipments(): Promise<IDhlShipment[]> {
      if (this.allDhlShipmentsLoaded) {
        return Promise.resolve(this.allDhlShipments)
      }

      return new Promise((resolve) => {
        let resolved = false

        const accountStore = useAccountStore()

        const q = query(
          collection(db, 'Apps', '-lab-customer-', 'DhlShipments'),
          where('labAccountID', '==', accountStore.labAccount?.id)
        )

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          this.allDhlShipments = querySnapshot.docs.map(
            (docSnap) => ({ id: docSnap.id, ...docSnap.data() }) as IDhlShipment
          )

          if (!resolved) {
            resolved = true
            resolve(this.allDhlShipments)
          }
        })

        this.unsubscribeAllDhlShipments = unsubscribe
      })
    },

    // Hydrates from a Display's public data endpoint — see orderStore.ts.
    hydrateFromPublicData(raw: unknown[]): void {
      this.allDhlShipments = raw as IDhlShipment[]
    },

    resetStore(): void {
      this.allDhlShipments = []

      if (this.unsubscribeAllDhlShipments) {
        this.unsubscribeAllDhlShipments()
        this.unsubscribeAllDhlShipments = null
      }
    },
  },
})
